import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../services/api";
import { nav as routeNav } from "../../utils/nav"; // ← yksi nav-helperi

export default function Start() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    let cancelled = false;

    const goLogin = () => {
      const next = `${loc.pathname}${loc.search || ""}${loc.hash || ""}`;
      navigate(`/kirjaudu?next=${encodeURIComponent(next)}`, { replace: true });
    };

    (async () => {
      if (!user) return goLogin();

      // Ehtojen / tietosuojan hyväksyntä
      const needsAccepts = !user.accepted_terms_at || !user.accepted_privacy_at;
      if (needsAccepts) {
        navigate("/onboarding", { replace: true });
        return;
      }

      // Onko esiintyjäkortteja?
      let bands = [];
      try {
        const res = await api.auth.meBands();
        bands =
          Array.isArray(res?.bands) ? res.bands :
          Array.isArray(res?.memberships) ? res.memberships :
          Array.isArray(res?.items) ? res.items :
          Array.isArray(res) ? res : [];
      } catch (_) {}

      if (cancelled) return;

      // Setup-wizardin “valmis”-lippu (kertaluonteinen ohitus)
      const justCompleted = (() => {
        try { return sessionStorage.getItem("setup.completed") === "1"; }
        catch { return false; }
      })();

      // Ei enää automaattista setup-redirectiä.
      // Lisäkortin wizardiin mennään vain /dashboard?band=new tai /setup/add
      if (bands.length === 0) {
        try { sessionStorage.removeItem("dashboard.skipSetupOnce"); } catch {}
        if (justCompleted) {
          try { sessionStorage.removeItem("setup.completed"); } catch {}
        }
        routeNav.toDashboardUser(navigate, true);
      } else {
        try { localStorage.setItem("dashboard.hadBandsOnce", "1"); } catch {}
        routeNav.toDashboardBand(navigate, "auto", "basic", true);
      }
    })();

    return () => { cancelled = true; };
  }, [user, navigate, loc.pathname, loc.search, loc.hash]);

  return null; // ei UI:ta, pelkkä ohjaus
}
